import React, { useState, useEffect } from "react";
import ViewSales from "./ViewSales";
import useDefaultCurrency from "../../utility/useDefaultCurrency";
import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";

function SalesTableBody({ ordersData }) {
  const { data } = useDefaultCurrency("manager");
  const [currency, setCurrency] = useState(null);
  function statusFormat(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);

    // Format the date
    const formattedDate = date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "2-digit", // Use "long" for full month name
      day: "2-digit",
    });
    return `${formattedDate}`; // Combine date and time
  };

  useEffect(() => {
    setCurrency(data?.currency?.symbol);
  }, [data]);
  useEffect(() => {}, [currency]);

  return (
    <tbody>
      {ordersData.map((item) => (
        <tr
          key={item?.id}
          className="hover:bg-gray-100 border-b border-gray-300"
        >
          <td className="py-2 px-4 text-wrap">{item?.orderNO}</td>
          <td className="py-2 px-4 text-center text-wrap">
            {item?.customer?.name}
          </td>
          <td className="py-2 px-4 text-center text-wrap">
            {item?.user?.firstname} {item?.user?.lastname}
          </td>
          <td className="py-2 px-4 text-center text-wrap">
            {currency} {formatNumbersWithDecimal(item?.total_price)}
          </td>
          <td className="py-2 px-4 text-center text-wrap">
            {formatDateTime(item?.updated_at)}
          </td>
          <td className="py-2 px-4 text-center text-wrap">
            <div
              className={`p-1 rounded-md text-white ${
                item.status === "COMPLETED" ? "bg-green-500" : "bg-yellow-500"
              }`}
            >
              {statusFormat(item?.status)}
            </div>
          </td>
          <ViewSales item={item} currency={currency} />
        </tr>
      ))}
    </tbody>
  );
}

export default SalesTableBody;
